import script from "./BudgetConsumptionReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./BudgetConsumptionReport.vue?vue&type=script&setup=true&lang=ts"

import "./BudgetConsumptionReport.vue?vue&type=style&index=0&id=1b78b26a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b78b26a"]])

export default __exports__